<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Document Library</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align: center">
          <span class="page-sub-title"> Document Library </span>
        </h3>
        <p-treeTable
          #tt
          [value]="files"
          [columns]="cols"
          selectionMode="checkbox"
          [scrollable]="true"
          [(selection)]="selectedNodes"
          [sortField]="cols[0]?.field"[sortOrder]="1"
        >
          <ng-template pTemplate="caption">
            <div class="p-d-flex">
              <input
                class="p-checkbox p-component margin-right-5"
                type="checkbox"
                [(ngModel)]="selectAll"
                (change)="checkAllNodes($event)"
              />
              <span class="select-all">Select All</span>
              <span
                *ngIf="
                  independentPermissions.DL_Add ||
                  independentPermissions.DL_Admin
                "
              >
                <p-button
                  icon="pi pi-download"
                  styleClass="p-button-warning  button-submit"
                  label="Download"
                  (click)="downloadSelected()"
                  [style]="{ 'margin-left': '1em' }"
                ></p-button>
                <p-button
                  icon="pi pi-plus"
                  styleClass="p-button-warning  button-add"
                  label="Add Folder at Root"
                  (click)="addFolderOrFileBtn(0, DocumentType.Folder)"
                  [style]="{ 'margin-left': '1em' }"
                ></p-button>
              </span>
              <div class="global-search">
                <i class="pi pi-search" style="margin: 4px 4px 0 0"></i>
                <input
                  type="text"
                  pInputText
                  size="50"
                  placeholder="Search"
                  (input)="tt.filterGlobal($event.target.value, 'contains')"
                  style="width: auto"
                />
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ttSortableColumn]="col.field">
                {{ col.header }}
                <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
              </th>
              <th style="width: 20rem">
                {{ "Action" }}
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-rowNode
            let-rowData="rowData"
            let-columns="columns"
          >
            <tr
              [ngStyle]="{
                background: rowData.isNew && rowData.isActive ? '#ffcdb296' : ''
              }"
            >
              <td *ngFor="let col of columns; let i = index">
                <p-treeTableToggler
                  [rowNode]="rowNode"
                  *ngIf="i == 0"
                ></p-treeTableToggler>
                <img
                  *ngIf="i == 0 && rowData.isNew && rowData.isActive"
                  height="18px"
                  width="25px"
                  style="background-color: #ffffff; margin-right: 3px"
                  src="assets/images/dl-new.png"
                />
                <input
                  *ngIf="i == 0"
                  [ngStyle]="{
                    'margin-left':
                      !(rowData.isNew && rowData.isActive) && '27px'
                  }"
                  class="p-checkbox p-component margin-right-5"
                  type="checkbox"
                  [checked]="rowNode.node.data.isChecked"
                  [indeterminate]="rowNode.node.data.indeterminate"
                  (change)="checkNode(rowNode.node, $event)"
                />
                <i
                  [ngStyle]="{
                    color: rowData.isActive ? 'black' : 'lightgray'
                  }"
                  *ngIf="
                    rowData.type == DocumentType.Folder && col.header == 'Name'
                  "
                  style="font-size: 1.5rem"
                  class="pi pi-folder"
                ></i>
                <i
                  [ngStyle]="{
                    color: rowData.isActive ? 'black' : 'lightgray'
                  }"
                  *ngIf="
                    rowData.type == DocumentType.File && col.header == 'Name'
                  "
                  style="font-size: 1.5rem"
                  class="pi pi-file-pdf"
                ></i>
                <span
                  [ngStyle]="{
                    color: rowData.isActive ? 'black' : 'lightgray'
                  }"
                >
                  <span style="margin-left: 5px">{{ rowData[col.field] }}</span>
                  <span
                    *ngIf="
                      rowData.type == DocumentType.File && col.header == 'Name'
                    "
                    >
                    <!-- {{ ".pdf" }} -->
                    </span
                  >
                </span>
              </td>
              <td style="padding: 0px" >
                <ul
                  class="list-inline links-list library-menulist"
                  style="margin-bottom: 0px"
                >
                  <li class="dropdown language-selector">
                    <a
                      href="#"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      data-close-others="true"
                    >
                      <img
                        src="assets/images/dot-icon.png"
                        width="100%"
                        alt=""
                        class="img-circle"
                      />
                    </a>

                    <ul class="dropdown-menu pull-right">
                      <li class="active" *ngIf="rowData.type == DocumentType.Folder && (independentPermissions.DL_Add || independentPermissions.DL_Admin) && rowData.isActive == true">
                        <a (click)="addFolderOrFileBtn(rowData.Id,DocumentType.Folder)" style="cursor: pointer">
                          <i
                            class="entypo-plus-circled"
                            style="color: #006a6c"
                          ></i>
                          Add Folder
                        </a>
                      </li>

                      <li class="active" *ngIf="rowData.type == DocumentType.File || (rowData.type == DocumentType.Folder && rowData.isChecked == true)">
                        <a (click)="downloadFileOrFolder(rowNode.node,rowData.type)" style="cursor: pointer">
                          <i class="entypo-download" style="color: #00ae9e"></i>
                          Download
                        </a>
                      </li>
                      <li class="active"  *ngIf="rowData.type == DocumentType.File">
                        <a (click)="showDialog(rowNode.node)" style="cursor: pointer">
                          <i class="entypo-eye" style="color: #00ae9e"></i>
                          View File
                        </a>
                      </li>

                     

                      <li class="active" *ngIf="rowData.type == DocumentType.Folder && (independentPermissions.DL_Add || independentPermissions.DL_Admin) && rowData.isActive == true">
                        <a (click)="addFolderOrFileBtn(rowData.Id,DocumentType.File)" style="cursor: pointer">
                          <i
                            class="entypo-upload-cloud"
                            style="color: #473192"
                          ></i>
                          Upload File
                        </a>
                      </li>

                      <li class="active" *ngIf="(independentPermissions.SUPER_Admin  ) && rowData.isActive == false">
                        <a (click)="confirmRevert(rowNode.node)" style="cursor: pointer">
                          <i class="entypo-logout" style="color: #5f5858"></i>
                          Revert Folder
                        </a>
                      </li>

                      <li class="active" *ngIf="( independentPermissions.SUPER_Admin ) && rowData.isActive == true">
                        <a (click)="RenameBtn(rowNode.node)" style="cursor: pointer">
                          <i class="entypo-pencil" style="color: #659dc9"></i>
                          Rename <span *ngIf="rowData.type == DocumentType.Folder">Folder</span>
                          <span *ngIf="rowData.type == DocumentType.File">File</span>
                        </a>
                      </li>

                      <li class="active" *ngIf="(independentPermissions.DL_Add || independentPermissions.DL_Admin) && rowData.isActive == true">
                        <a (click)="confirmDelete(rowNode.node)" style="cursor: pointer">
                          <i class="entypo-trash" style="color: #ac172b"></i>
                          Delete
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="fileUploadDialog"
  (onHide)="closePopUp()"
  header="Upload File To Current Folder"
  [modal]="true"
  [style]="{ width: '800px' }"
>
  <div class="p-field">
    <label for="name">Select File Type:<span class="mandatory">*</span></label>
    <p-dropdown
      [style]="{ width: '100%' }"
      [options]="fileTypes"
      [(ngModel)]="selectedfileFormat"
      (onChange)="selectNameFormat($event.value)"
      placeholder="Select File Type"
    >
    </p-dropdown>
    <div style="margin-top: 15px">
      <label for="name">Enter File Name:<span class="mandatory">*</span></label>
      <div class="clearfix"></div>

      <input
        type="text"
        placeholder="Edit File Name"
        [(ngModel)]="document.Name"
      />
      <!-- {{ ".pdf" }} -->
    </div>
    <label style="margin-top: 10px" for="name"
      >Enter Version:<span class="mandatory">*</span></label
    >
    <input type="number" step="0.1" pInputText [(ngModel)]="document.Version" min="0"/>
    <label for="name" style="margin-top: 10px"
      >Upload File:<span class="mandatory">*</span></label
    >
    <ara-file-upload
      [inputFiles]="document.File"
      [accept]="accept"
      [multiple]="false"
      (onInputFilesUpdatedData)="onInputFilesUpdated($event)"
      [disabled]="false"
    >
    </ara-file-upload>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Save"
      (click)="uploadFileOrFolder(DocumentType.File)"
      [disabled]="
        document.Name == '' ||
        document.Name == null ||
        selectedfileFormat == '' ||
        selectedfileFormat == null ||
        document.Version == '' ||
        document.Version == null ||
        !document.File.length
      "
      icon="pi pi-check"
      class="p-button-text"
    ></button>
    <button
      pButton
      pRipple
      label="Cancel"
      (click)="fileUploadDialog = false"
      icon="pi pi-times"
      class="p-button-text button-cancel"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="addFolderDialog"
  (onHide)="closePopUp()"
  header="Add Folder"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="p-field">
    <label for="name">Enter Folder Name:<span class="mandatory">*</span></label>
    <input type="text" pInputText [(ngModel)]="document.Name" required />
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Save"
      (click)="uploadFileOrFolder(DocumentType.Folder)"
      [disabled]="document.Name == '' || document.Name == null"
      icon="pi pi-check"
      class="p-button-text"
    ></button>
    <button
      pButton
      pRipple
      label="Cancel"
      (click)="addFolderDialog = false"
      icon="pi pi-times"
      class="p-button-text"
    ></button>
  </ng-template>
</p-dialog>
<p-dialog
  header="Preview"
  [(visible)]="display"
  [style]="{ width: '60vw', top: '20px' }"
>
  <div style="height: 1000px">
      <pdf-viewer [src]="PreviewUrl" [render-text]="true" style="display: block">
    </pdf-viewer>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="EditFolderDialog"
  (onHide)="closePopUp()"
  header="Rename {{ EditType }}"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="p-field">
    <label for="name">Current {{ EditType }} Name: </label>
    <label type="name">{{ EditName }} </label>
  </div>
  <div class="p-field">
    <label for="name"
      >New {{ EditType }} Name:<span class="mandatory">*</span></label
    >
    <input type="text" pInputText [(ngModel)]="document.Name" />
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Rename"
      (click)="RenameFileOrFolder()"
      [disabled]="document.Name == '' || document.Name == null"
      icon="pi pi-check"
      class="p-button-text"
    ></button>
    <button
      pButton
      pRipple
      label="Cancel"
      (click)="EditFolderDialog = false"
      icon="pi pi-times"
      class="p-button-text"
    ></button>
  </ng-template>
</p-dialog>

<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (okClicked)="onOkClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (yesClicked)="onYesClickedForConfirmation()"
  (noClicked)="onNoClickedForConfirmation()"
></ara-alerts>
